import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import { parseDateTime, stringifyDateTime } from '~/prix/types/dateTime'
import clearString from '~/prix/utils/bulk/clearString'
import { parseBooleanValue } from '~/prix/utils/bulk/csvValueParsers'

const healthUnit: Dataset = {
  schema: 'public_health',
  table: 'health_unit',
  columnTransformMap: {
    original_id: original => original,
    cnes: original => original,
    is_active: original => parseBooleanValue(original as string),
    cnpj: original => original,
    name: original => clearString(original as string),
    phone: original => original,
    postal_code: original => original,
    street_name: original => (original ? (original as string) : null),
    complement: original => (original ? (original as string) : null),
    reference_point: original => clearString(original as string),
    neighborhood: original => clearString(original as string),
    municipality: original => clearString(original as string),
    state: original => clearString(original as string),
    street_type: original => (original ? (original as string) : null),
    street_number: original => original,
    health_unit_type: original => clearString(original as string),
    health_unit_subtype: original => clearString(original as string),
    data_source_id: original => (original != null ? Number(original) : null),
    created_at: original => stringifyDateTime(parseDateTime(original as string)),
    updated_at: original => stringifyDateTime(parseDateTime(original as string)),
  },
}

export default healthUnit
